import { Link } from 'react-router-dom';
import { articles } from '@/mocks/categories';

export default function ArticlesSection() {
  const additionalArticles = articles.slice(1);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            More <strong className="text-accent-600">Pandabuy Sheet</strong> Guides &amp; Resources
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            In-depth articles and tutorials to help you get the most out of your pandabuyspreadsheet experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {additionalArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 hover:shadow-sm transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-700 bg-accent-100/90 backdrop-blur-sm rounded-full px-3 py-1 font-label">
                    <i className="ri-article-line"></i> {article.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center justify-between mt-auto">
                  <span className="text-xs text-foreground-400 font-label flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold font-label text-primary-600 group-hover:gap-1.5 transition-all duration-200 whitespace-nowrap">
                    Read More <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}